/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gross_Alive_Moth_SwayInputs */

const es_gross_alive_moth_sway = /** @type {(inputs: Gross_Alive_Moth_SwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservar`)
};

const gl_gross_alive_moth_sway = /** @type {(inputs: Gross_Alive_Moth_SwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reservar`)
};

const en_gross_alive_moth_sway = /** @type {(inputs: Gross_Alive_Moth_SwayInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Book`)
};

/**
* | output |
* | --- |
* | "Book" |
*
* @param {Gross_Alive_Moth_SwayInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const gross_alive_moth_sway = /** @type {((inputs?: Gross_Alive_Moth_SwayInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gross_Alive_Moth_SwayInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_gross_alive_moth_sway(inputs)
	if (locale === "en") return en_gross_alive_moth_sway(inputs)
	return es_gross_alive_moth_sway(inputs)
});